<p>Change your future percentage of work if you anticipate working part-time.</p>
<p>We have set a default value of 100%.</p>
